import React from 'react';
import './KpiCard.css';

const KpiCard = ({
	title,
	value,
	isCurrency,
	isPositive,
	isNegative,
	isEmphasized,
	onClick,
}) => {
	const formatCurrency = (value) => {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(value);
	};

	const getValueClass = () => {
		if (isEmphasized) return 'kpi-value emphasized';
		if (isPositive) return 'kpi-value positive';
		if (isNegative) return 'kpi-value negative';
		return 'kpi-value';
	};

	return (
		<div className={`kpi-card ${onClick ? 'clickable' : ''}`} onClick={onClick} style={onClick ? { cursor: 'pointer' } : {}}>
			<div className="kpi-title">{title}</div>
			<div className={getValueClass()}>
				{isCurrency ? formatCurrency(value) : value}
			</div>
		</div>
	);
};

export default KpiCard;
